import React, { useState } from 'react'
import clsx from 'clsx'
import { CategoriesMenuProps } from '@/components/organisms/IntegrationsGrid/types'

export function CategoriesMenu({
  setActiveCategory,
  categories,
  className,
  activeCategory,
  all_integrations_label
}: CategoriesMenuProps) {
  const handleClick = (item: string | undefined) => {
    if (setActiveCategory && item) {
      setActiveCategory(item)
    }
  }

  const getMenuItemClassname = (item: string | undefined) =>
    clsx(
      'cursor-pointer border-1 border-white text-bodyL w-full text-start rounded netbook:font-bold text-text-dark-900 netbook:px-24 netbook:py-12 p-10 hover:bg-primary-100 transition',
      {
        '!border-1 !border-primary-500 bg-primary-100 !text-primary-600 font-bold': activeCategory === item
      }
    )

  return (
    <aside className={clsx('laptop:max-w-21 flex-1 flex flex-col', className)}>
      <div className="flex flex-col gap-4">
        <button
          type="button"
          aria-label={`Show ${all_integrations_label}`}
          onClick={() => handleClick(all_integrations_label)}
          className={getMenuItemClassname(all_integrations_label)}
        >
          {all_integrations_label || 'All Integrations'}
        </button>
        {categories.length > 0 &&
          categories.map((item) => (
            <button
              key={JSON.stringify(item)}
              type="button"
              aria-label={`Show ${item} integrations`}
              onClick={() => handleClick(item)}
              className={getMenuItemClassname(item)}
            >
              {item}
            </button>
          ))}
      </div>
    </aside>
  )
}

export function MobileCategoriesMenu({
  setActiveCategory,
  activeCategory,
  categories,
  className,
  select_category_label,
  all_integrations_label
}: CategoriesMenuProps) {
  const [isOpen, setIsOpen] = useState(false)

  const handleClick = (item: string) => {
    if (setActiveCategory) {
      setActiveCategory(item)
    }
    setIsOpen((prevIsOpen) => !prevIsOpen)
  }

  return (
    <div className={clsx('flex flex-col gap-2 relative z-20', className)}>
      <button
        type="button"
        aria-label="Open Integrations Select menu"
        className="flex w-full items-center justify-between cursor-pointer border-1 border-grey-100 text-bodyM text-start rounded font-semibold text-text-dark-900 p-16 transition leading-tight "
        onClick={() => setIsOpen(!isOpen)}
      >
        {activeCategory === all_integrations_label ? select_category_label : activeCategory}
        <i
          className={clsx(isOpen && '-rotate-180', 'fa fa-chevron-down ml-auto netbook:ml-8 duration-300')}
          aria-hidden="true"
        />
      </button>
      {isOpen && (
        <div className="h-full w-full absolute -bottom-[calc(100%+8px)] left-0" aria-expanded={isOpen}>
          <CategoriesMenu
            all_integrations_label={all_integrations_label}
            activeCategory={activeCategory}
            categories={categories}
            setActiveCategory={handleClick}
            className="bg-white p-8 border-1 border-grey-100 shadow-md rounded"
          />
        </div>
      )}
    </div>
  )
}
